import { MoveHorizontal, Minus, Plus } from "lucide-react";

const AdminSyncOffsetEditor = ({ value, onChange }) => {
  const update = (amount) => onChange(Number((Number(value || 0) + amount).toFixed(2)));
  return (
    <section className="rounded-2xl border border-white/10 bg-black/20 p-3">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="flex items-center gap-2 text-sm font-semibold text-white"><MoveHorizontal className="h-4 w-4 text-cyan-200" /> Sync offset global</p>
          <p className="text-xs text-slate-400">Mueve toda la timeline y escucha el ajuste en preview.</p>
        </div>
        <div className="flex items-center gap-2">
          <button type="button" onClick={() => update(-0.5)} className="grid h-11 w-11 place-items-center rounded-xl border border-white/10 text-white"><Minus className="h-4 w-4" /></button>
          <span className="min-w-20 text-center font-mono text-sm font-semibold text-cyan-100">{Number(value || 0) > 0 ? "+" : ""}{Number(value || 0).toFixed(2)}s</span>
          <button type="button" onClick={() => update(0.5)} className="grid h-11 w-11 place-items-center rounded-xl border border-white/10 text-white"><Plus className="h-4 w-4" /></button>
        </div>
      </div>
      <input
        aria-label="Offset de sincronizacion"
        className="mt-4 w-full accent-cyan-300"
        type="range"
        min="-10"
        max="10"
        step="0.05"
        value={value || 0}
        onChange={(event) => onChange(Number(event.target.value))}
      />
    </section>
  );
};

export default AdminSyncOffsetEditor;
